import { render } from "./Coupons.vue?vue&type=template&id=c95eb854&ts=true"
import script from "./Coupons.vue?vue&type=script&lang=ts"
export * from "./Coupons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__